/**
 * Helper to download file
 * @param file
 * @param fileName (default: 'participant-list.csv')
 */
function downloadFile(file, fileName = "participant-list.csv") {
  // NOTE: we need to aware of Blob type constructor, some old browser might not support this library.
  const url = window.URL.createObjectURL(new Blob([file]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function downloadFileFromURL(url, fileName = "participant-list.csv") {
  // NOTE: we need to aware of Blob type constructor, some old browser might not support this library.
  // const url = window.URL.createObjectURL(new Blob([file]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

module.exports = {
  downloadFile,
  downloadFileFromURL
};



// WEBPACK FOOTER //
// ./src/utils/download-file.js